export { default as theme } from 'prismjs/themes/prism-funky.css';
